import baseURL from "../common/axios";

class campaignService {
  //To Insert Campaign-->MOPCRM API
  Create(formdata) {
    return baseURL.httpMSMOPCRMUrl.post("Campaign/Create", formdata);
  }
  //To Update Campaign-->MOPCRM API
  Update(formdata) {
    return baseURL.httpMSMOPCRMUrl.post("Campaign/Update", formdata);
  }
  //To List Campaign-->MOPCRM API
  List() {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/List");
  }
  //To GetById Campaign-->MOPCRM API
  GetById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/Get?Id=" + Id + "");
  }
  //To GetById Campaign-->MOPCRM API
  DeleteById(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("Campaign/Delete?Id=" + Id + "");
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put("Campaign/Active?Id=" + Id + "&Status=" + Status + ""
    );
  }

  //TemplateMasterList
  TemplateMasterList(
    clientId,
    entityId,
  ) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Campaign/TemplateMasterList?ClientId=" +
      clientId +
      "&EntityID=" +
      entityId +
      ""
    );
  }
  //MessageTypeList
  MessageTypeList(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/MessageTypeList?ClientId=" + Id + "");
  }
  //CampaignContactsList
  CampaignContactsList(Condition) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/CampaignContactsList?Condition=" + Condition + "");
  }
  //CampaignLeadList
  CampaignLeadList(Condition) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/CampaignLeadList?Condition=" + Condition + "");
  }

  //CampaignLeadList
  TemplateVariableList(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/TemplateVariableList?ClientId=" + Id + "");
  }

  CreateCampaignRecipients(formdata) {
    return baseURL.httpMSMOPCRMUrl.post("Campaign/CreateCampaignRecipients", formdata);
  }

  CreateSMSDetails(formdata) {
    return baseURL.httpMSMOPCRMUrl.post("Campaign/CreateSMSDetails", formdata);
  }

  GetByCampaignId(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/CampaignSMSDetailsList?CampaignId=" + Id + "");
  }

  GetRecipientByCampaignId(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/GetCampaignRecipientsByID?id=" + Id + "");
  }

  RepeatList() {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/CampaignRepeatList");
  }

  GetPatientList(
    hosplitalId,
    branchId,
    name,
    diagnosis,
    visittype
  ) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Campaign/GetPatientListFromHMS?hosplitalId=" +
      hosplitalId +
      "&branchId=" +
      branchId +
      "&name=" +
      name +
      "&diagnosis=" +
      diagnosis +
      "&VisitType=" +
      visittype +
      ""
    );
  }

  GetPatientGroup(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/GetPatientGroupList?Dml_Indicator=" + Id + "");
  }

  GetCredits(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Campaign/CreditsList?ClientId=" + Id + "");
  }
}
export default new campaignService();
